import { render, staticRenderFns } from "./payment_status.vue?vue&type=template&id=a85f9e5c&"
import script from "./payment_status.vue?vue&type=script&lang=js&"
export * from "./payment_status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports